import GenericDialog from 'portal/src/components/common/GenericDialog';

import UserForm from '../UserForm';

const AddOrUpdateUserDialog = ({
  entity = {},
  open,
  onClose,
  onSave,
}: {
  entity?: any;
  open: boolean;
  onClose: () => void;
  onSave: (data: any) => void;
}) => {
  return (
    <GenericDialog open={open} onClose={onClose}>
      <UserForm
        entity={entity}
        backButtonlabel="Cancel"
        buttonLayout="bottom"
        isPending={false}
        handleBackAction={onClose}
        header={`${Object.keys(entity).length ? 'Edit' : 'Add'} User`}
        isNewOrg
        onSave={onSave}
        orgFieldDisabled
        removeContainerStyle
      />
    </GenericDialog>
  );
};

export default AddOrUpdateUserDialog;
